import { Layout, Box, SplitLoginLayout, Text } from "@flexisaf/flexibull2";
import moment from "moment";
import PackageJSON from "../../package.json";
import Theme from "../theme";
import LoginBG from "../assets/loginbg.svg";
import BrandLOGO from "../assets/whitesaflearnlogo.svg";

const LoginLayout = ({ children }) => {
  return (
    <Layout theme={Theme}>
      <SplitLoginLayout
        image={LoginBG}
        brand={<img src={BrandLOGO} alt="brand-logo" />}
        leftFoot={
          <Box>
            <Text block>Version {PackageJSON?.version ?? `1.0.0`}</Text>
            <Text>
              Copyright © {moment().format("YYYY")}{" "}
              <strong>Flexisaf Edusoft Limited.</strong> All rights reserved.
            </Text>
          </Box>
        }
      >
        {children}
      </SplitLoginLayout>
    </Layout>
  );
};

export default LoginLayout;
